// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreditData_wrapper__3c14v","left":"CreditData_left__2TsZ5"};